export default {
  q1: [],
  q1_complete: '',
  q2: [],
  q3: [],
  q4: [],
  q5: '',
  q6: ''
};
